import useSWR, { mutate } from "swr"
import API from "./api"

export default function useResource({
  key,
  url,
  parentKeys = [],
  params = {},
  localMutate = false,
  mutateFromUpdate = false,
  resourceType = undefined,
  swrOptions = {},
}) {
  const apiPath = url || key

  function getWithParams() {
    return API.get(apiPath, params)
  }

  function updateLocal(data, localData) {
    mutate(key, { ...data, ...localData }, false)
  }

  async function update(data, localData) {
    if (localMutate) {
      mutate(key, data, false)
      await API.put(apiPath, data)
    } else if (mutateFromUpdate) {
      await mutate(key, API.put(apiPath, data))
    } else {
      if (localData) {
        mutate(key, localData, false)
      }

      const result = await API.put(apiPath, data)

      mutate(key)
      parentKeys.map((key) => mutate(key))

      return result
    }

    return Promise.all(parentKeys.map((key) => mutate(key)))
  }

  async function create(params = {}) {
    await API.post(apiPath, params)
    return Promise.all(parentKeys.map((key) => mutate(key)))
  }

  async function destroy(params = {}) {
    await API.delete(apiPath, params)
    return Promise.all(parentKeys.map((key) => mutate(key)))
  }

  function refresh() {
    return mutate(key)
  }

  const { data, isValidating } = useSWR(key, getWithParams, {
    suspense: true,
    ...swrOptions,
  })

  if (typeof data === "object") {
    data.create = create
    data.update = update
    data.updateLocal = updateLocal
    data.destroy = destroy
    data.refresh = refresh
    data.isValidating = isValidating

    if (resourceType) {
      data.resource_type = resourceType
    }
  }

  return [data, { create, update, destroy, refresh, updateLocal }]
}
